export default __webpack_public_path__ + "static/media/correct2.141c70bc.png";